"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertConfigToNumber = exports.isSantaFullWidthMode = exports.isVideo = exports.getMediaUrl = exports.resizeMediaByWidth = exports.getFullSizedMediaUrl = exports.getMainImageRatio = exports.adjustImageDimensionToContainer = void 0;
var tslib_1 = require("tslib");
var lodash_1 = tslib_1.__importDefault(require("lodash"));
var imageClientSDK_1 = tslib_1.__importDefault(require("image-client-api/dist/imageClientSDK"));
var media_item_1 = require("../types/media-item");
var constants_1 = require("./constants");
var SSR_IMAGE_CONFIG = {
    clientSdkOptions: {
        quality: 50,
        isSEOBot: true,
    },
};
function getMediaRatioByDistance(media) {
    var mediaRatio = media ? media.height / media.width : 1;
    var distanceArray = calculateDistanceBetweenRatios(mediaRatio);
    var closestRatioByDistanceIndex = getMinValueIndex(distanceArray);
    return constants_1.ImageRatioList[closestRatioByDistanceIndex];
}
function getImageRatioById(id) {
    return constants_1.ImageRatioList.filter(function (item) {
        return item.sdkId === id;
    })[0];
}
function calculateDistanceBetweenRatios(imageRatio) {
    return constants_1.ImageRatioList.map(function (imageRatioItem) {
        var ratioVal = getImageRatioValue(imageRatioItem);
        return Math.abs(ratioVal - imageRatio);
    });
}
function getMinValueIndex(distanceArray) {
    var minValue = Math.min.apply(Math, tslib_1.__spreadArray([], tslib_1.__read(distanceArray), false));
    return distanceArray.indexOf(minValue);
}
function getImageRatioValue(imageRatioItem) {
    return imageRatioItem.ratio.height / imageRatioItem.ratio.width;
}
function limitDimensions(width, height) {
    var MAX_IMAGE_DIMENSION = 5000;
    var divider = Math.max(1, width / MAX_IMAGE_DIMENSION, height / MAX_IMAGE_DIMENSION);
    return {
        width: width / divider,
        height: height / divider,
    };
}
function isValidMedia(media) {
    return (media !== null &&
        typeof media === 'object' &&
        [media_item_1.MediaType.PHOTO, media_item_1.MediaType.VIDEO].includes(media.mediaType) &&
        typeof media.url === 'string');
}
function adjustImageDimensionToContainer(media, container, imageMode, options) {
    if (options === void 0) { options = {}; }
    var getFactor = options.upsclae ? Math.max : Math.min;
    if (imageMode === 2 /* ImageMode.FIT */) {
        var factor = getFactor(1, container.width / media.width, container.height / media.height);
        return {
            width: media.width * factor,
            height: media.height * factor,
        };
    }
    return container;
}
exports.adjustImageDimensionToContainer = adjustImageDimensionToContainer;
function getMainImageRatio(media, imageRatioId) {
    if (lodash_1.default.isNumber(imageRatioId) && imageRatioId > -1) {
        return getImageRatioById(imageRatioId);
    }
    else {
        return getMediaRatioByDistance(media);
    }
}
exports.getMainImageRatio = getMainImageRatio;
function getFullSizedMediaUrl(media) {
    var width = media.width, height = media.height;
    return getMediaUrl(media, { width: width, height: height });
}
exports.getFullSizedMediaUrl = getFullSizedMediaUrl;
function resizeMediaByWidth(media, width) {
    var height = media.height / (media.width / width);
    return {
        width: Math.round(width),
        height: Math.round(height),
    };
}
exports.resizeMediaByWidth = resizeMediaByWidth;
function getMediaUrl(media, _a, _b) {
    var width = _a.width, height = _a.height;
    var _c = _b === void 0 ? {
        isSSR: false,
        imageMode: null,
        asJpg: false,
        isSEOBot: false,
    } : _b, isSSR = _c.isSSR, imageMode = _c.imageMode, asJpg = _c.asJpg, isSEOBot = _c.isSEOBot;
    if (!isValidMedia(media) || !width) {
        return '';
    }
    var mediaWidth = Number(media.width);
    var mediaHeight = Number(media.height);
    var nextHeight = height || resizeMediaByWidth(media, width).height;
    var _d = limitDimensions(width, nextHeight), newWidth = _d.width, newHeight = _d.height;
    var options = {
        quality: 85,
    };
    if (isSSR) {
        options = SSR_IMAGE_CONFIG.clientSdkOptions;
    }
    else if (imageMode === 1 /* ImageMode.CROP */ && (mediaWidth < newWidth || mediaHeight < newHeight)) {
        options.upscaleMethod = 'auto';
    }
    if (isSEOBot) {
        options.isSEOBot = true;
    }
    var targetWidth = Math.round(newWidth);
    var targetHeight = Math.round(newHeight);
    var imageUrl = imageClientSDK_1.default.getScaleToFillImageURL(media.url, mediaWidth, mediaHeight, targetWidth, targetHeight, options);
    return asJpg ? imageUrl.replace(/\.png$/, '.jpg') : imageUrl;
}
exports.getMediaUrl = getMediaUrl;
function isVideo(mediaItem) {
    return mediaItem && mediaItem.mediaType === media_item_1.MediaType.VIDEO;
}
exports.isVideo = isVideo;
function isSantaFullWidthMode(props) {
    var width = props.dimensions.width;
    return String(width) === '';
}
exports.isSantaFullWidthMode = isSantaFullWidthMode;
function convertConfigToNumber(dimensions, base) {
    var unit = dimensions.unit, num = dimensions.num;
    if (unit === 'px') {
        return num;
    }
    if (unit === '%' && !isNaN(num)) {
        return base * (num / 100);
    }
    return 0;
}
exports.convertConfigToNumber = convertConfigToNumber;
//# sourceMappingURL=mediaService.js.map